export default __webpack_public_path__ + "static/5-7943e0947f2075780a019f92e7f0ae0a.png";